import { UserOutlined } from "@ant-design/icons"
import { Dropdown, Menu, Button } from "antd"
import Cookies from "js-cookie"
import { useContext } from "react"
import GeneralContext from "../../../context/GeneralContext/GeneralContext"
import { displayMessage } from '../../services/helper'

export default function ProfileOptions(props) {
  const {
    setLoggedUser,
    user, mobile_mode
  } = useContext(GeneralContext)

  const handleOnClickLogout = () => {
    setLoggedUser(false)
  }

  const items = [
    { key: '/logout', label: <div onClick={handleOnClickLogout} className="text-appian-blue">{displayMessage('LOGOUT')}</div> }
  ]

  const menu = items.map(item => (
    <Menu.Item key={item.key}>
      {item.label}
    </Menu.Item>
  ));

  return (
    <div
      className={`text-appian-blue_5 text-lg font-bold ${mobile_mode ? 'leading-none pr-5 mr-0' : 'leading-9 p-0 mr-5'} flex items-center `}>
      <Dropdown
        overlay={<Menu>{menu}</Menu>}
        placement="bottomLeft"
        size="large"
      >
        <Button
          icon={<UserOutlined className="text-xl text-white" />}
          className={`flex items-center justify-center ${mobile_mode ? 'min-h-[35px] min-w-[40px] mt-8' : 'min-h-[40px] min-w-[0px]'} text-sm text-white rounded`}
        >
          {!mobile_mode && `${user?.first_name} ${user?.last_name}`}
        </Button>
      </Dropdown>
    </div>

  )
}